import {Component, Input} from '@angular/core';
import {WidgetDataRetentionAndDeletionV0HeaderDto} from './models/widget-data-retention-and-deletion-v0-header.dto';

@Component({
  selector: 'pt-widget-data-retention-and-deletion-header-v0',
  template: `
    <thead class="bg-secondary text-white">
    <tr>
      <th class="m05" scope="col" rowspan="1">
        {{dataHeader?.category}}
      </th>
      <th class="m05" scope="col" rowspan="1" style="width: 160px;">
        {{dataHeader?.retentionPeriod}}
      </th>
      <th scope="col" rowspan="1" class="w-180 p05" >
        {{dataHeader?.retentionPeriodReason}}
      </th>
      <th scope="col" rowspan="1" class="w-220 p05">
        {{dataHeader?.action}}
      </th>
      <th scope="col" rowspan="1" class="w-180 p05">
        {{dataHeader?.note}}
      </th>
    </tr>
    </thead>
  `, styles: [`
    .p05 {
      padding: 0 5px;
    }
    .w-180 {
      width: 180px;
    }
    .w-220 {
      width: 220px;
    }
  `]
})
export class WidgetDataRetentionAndDeletionHeaderV0Component {

  @Input() dataHeader: WidgetDataRetentionAndDeletionV0HeaderDto;

}
